export var Labels = {
    useHomeAsBillingAddress: 'My billing address is the same as the address on my plan',
    addressLine1: 'Street address',
    addressLine2: 'Apartment, unit, suite (optional)',
    city: 'City / Town',
    state: 'County',
    zipCode: 'Postal code'
};
export var FieldErrors = {
    invalidAddressLine1: 'Please enter a valid street address',
    invalidAddressLine2: 'Please enter a street name', // Will retain this for future reference, address line 2 is optional in UK
    invalidCity: 'Please enter a valid city or town',
    invalidState: 'Please select a valid county',
    invalidZipCode: 'Please enter a valid postal code'
};
export var States = [
    { name: '- Unselect -', value: '' },
    { name: 'Bedfordshire', value: 'Bedfordshire' },
    { name: 'Berkshire', value: 'Berkshire' },
    { name: 'Bristol', value: 'Bristol' },
    { name: 'Buckinghamshire', value: 'Buckinghamshire' },
    { name: 'Cambridgeshire', value: 'Cambridgeshire' },
    { name: 'Cheshire', value: 'Cheshire' },
    { name: 'City of London', value: 'City of London' },
    { name: 'Cornwall', value: 'Cornwall' },
    { name: 'Cumbria', value: 'Cumbria' },
    { name: 'Derbyshire', value: 'Derbyshire' },
    { name: 'Devon', value: 'Devon' },
    { name: 'Dorset', value: 'Dorset' },
    { name: 'Durham', value: 'Durham' },
    { name: 'East Riding of Yorkshire', value: 'East Riding of Yorkshire' },
    { name: 'East Sussex', value: 'East Sussex' },
    { name: 'Essex', value: 'Essex' },
    { name: 'Gloucestershire', value: 'Gloucestershire' },
    { name: 'Greater London', value: 'Greater London' },
    { name: 'Greater Manchester', value: 'Greater Manchester' },
    { name: 'Hampshire', value: 'Hampshire' },
    { name: 'Herefordshire', value: 'Herefordshire' },
    { name: 'Hertfordshire', value: 'Hertfordshire' },
    { name: 'Isle of Wight', value: 'Isle of Wight' },
    { name: 'Kent', value: 'Kent' },
    { name: 'Lancashire', value: 'Lancashire' },
    { name: 'Leicestershire', value: 'Leicestershire' },
    { name: 'Lincolnshire', value: 'Lincolnshire' },
    { name: 'Merseyside', value: 'Merseyside' },
    { name: 'Norfolk', value: 'Norfolk' },
    { name: 'North Yorkshire', value: 'North Yorkshire' },
    { name: 'Northamptonshire', value: 'Northamptonshire' },
    { name: 'Northumberland', value: 'Northumberland' },
    { name: 'Nottinghamshire', value: 'Nottinghamshire' },
    { name: 'Oxfordshire', value: 'Oxfordshire' },
    { name: 'Rutland', value: 'Rutland' },
    { name: 'Shropshire', value: 'Shropshire' },
    { name: 'Somerset', value: 'Somerset' },
    { name: 'South Yorkshire', value: 'South Yorkshire' },
    { name: 'Staffordshire', value: 'Staffordshire' },
    { name: 'Suffolk', value: 'Suffolk' },
    { name: 'Surrey', value: 'Surrey' },
    { name: 'Tyne and Wear', value: 'Tyne and Wear' },
    { name: 'Warwickshire', value: 'Warwickshire' },
    { name: 'West Midlands', value: 'West Midlands' },
    { name: 'West Sussex', value: 'West Sussex' },
    { name: 'West Yorkshire', value: 'West Yorkshire' },
    { name: 'Wiltshire', value: 'Wiltshire' },
    { name: 'Worcestershire', value: 'Worcestershire' }
];
